import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";
import { pageFade } from "@/lib/motion";

/**
 * Animated outlet wrapper. Drop around <Outlet /> to get a 280ms fade-slide
 * between every route change inside the dashboard shell.
 */
export default function PageTransition({ children }) {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div key={location.pathname} {...pageFade}>
        {children}
      </motion.div>
    </AnimatePresence>
  );
}
